import { useState, useEffect } from 'react';

const MOCK_LOADING_DELAY = 3000;

export const useMockLoading = <T>(deps: any, data: T) => {
  const [isMockLoading, setIsMockLoading] = useState(true);

  useEffect(() => {
    if (!isMockLoading) return;
    const timer = setTimeout(() => setIsMockLoading(false), MOCK_LOADING_DELAY);
    return () => clearTimeout(timer);
  }, [isMockLoading]);

  useEffect(() => {
    setIsMockLoading(true);
  }, [deps]);

  return { isMockLoading, dataMock: isMockLoading ? undefined : data };
};
